'use client'

import * as React from 'react'
import { CheckIcon, CircleBackslashIcon } from '@radix-ui/react-icons'
import * as RadioGroupPrimitive from '@radix-ui/react-radio-group'
import { cn } from '../utils/cn'

const RadioGroup = React.forwardRef<React.ElementRef<typeof RadioGroupPrimitive.Root>, React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Root>>(
  ({ className, ...props }, ref) => {
    return (
      <RadioGroupPrimitive.Root
        className={cn('grid gap-2', className)}
        {...props}
        ref={ref}
      />
    )
  },
)
RadioGroup.displayName = RadioGroupPrimitive.Root.displayName

const RadioGroupItem = React.forwardRef<React.ElementRef<typeof RadioGroupPrimitive.Item>, React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item>>(
  ({ className, ...props }, ref) => {
    return (
      <RadioGroupPrimitive.Item
        ref={ref}
        className={cn(
          'aspect-square h-4 w-4 rounded-full border border-input text-primary  focus:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50  data-[state=checked]:border-[#80A8AE]',
          // 'aspect-square h-4 w-4 rounded-full border border-input text-primary shadow focus:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50  data-[state=checked]:border-[#80A8AE]',
          className,
        )}
        {...props}
      >
        <RadioGroupPrimitive.Indicator className="flex h-full items-center justify-center rounded-full border-2 border-background data-[state=checked]:bg-primary">
          {/* <RadioGroupPrimitive.Indicator className="flex items-center justify-center rounded-full data-[state=checked]:bg-red-500"> */}
          {/* <div className="h-[3px] w-[3px]  rounded-full data-[state=checked]:bg-red-500"></div> */}
          {/* data-[state=open] */}
          {/* <div className="h-full w-full bg-red-400"></div> */}
          {/* <CheckIcon className="h-3.5 w-3.5 bg-red-500" /> */}
          {/* <CircleBackslashIcon className="h-3.5 w-3.5 fill-foreground" /> */}
        </RadioGroupPrimitive.Indicator>
      </RadioGroupPrimitive.Item>
    )
  },
)
RadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName

export { RadioGroup, RadioGroupItem }
